export ImportedField from "./imported";
export CategoryField from "./category";
export CestField from "./cest";
export CfopField from "./cfop";
export CodeField from "./code";
export CsosnField from "./csosn";
export NameField from "./name";
export NcmField from "./ncm";
export SellValueField from "./sell-value";
export CostValueField from "./cost-value";
export BarcodeField from "./barcode";
export RestockCountField from "./restock-count";
export StockCountField from "./stock-count";
export UnitLabelField from "./unit-label";
export PisField from "./pis";
export CofinsField from "./cofins";
export OriginField from "./origin";



// WEBPACK FOOTER //
// ./src/components/app/registration/product/batch/fields/index.js